import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { buildTileLoggingData } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/buildLoggingData";
import { SDUIProductTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileRenderer";
import { SDUIProductTileWithBrand } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileWithBrandRenderer";
import { SDUIAvatarTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIAvatarTileRenderer";
import { SDUIBrandTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIBrandTileRenderer";
import { SDUIBrandTileWithActionRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIBrandTileWithActionRenderer";
import { SDUIImageGalleryTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIImageGalleryTileRenderer";
import { SDUIImageTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIImageTileRenderer";
import { SDUIPillTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUIPillTileRenderer";
import { SDUITextTileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/SDUITextTileRenderer";
import React, { useMemo } from "react";
import { SDUIBrandInsightsTileRenderer } from "./__internal__/SDUIBrandInsightsTileRenderer";
export var SDUITileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var TileComponent = getTileComponent(tileElement);
    var logging_data = tileElement.logging_data;
    var tileLoggingData = useMemo(function() {
        return buildTileLoggingData(loggingData, logging_data);
    }, [
        loggingData,
        logging_data
    ]);
    if (TileComponent === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(TileComponent, {
        tileElement: tileElement,
        loggingData: tileLoggingData
    });
};
var TileType;
(function(TileType) {
    TileType[TileType["BRAND_TILE"] = 0] = "BRAND_TILE";
    TileType[TileType["BRAND_TILE_WITH_PRODUCTS"] = 1] = "BRAND_TILE_WITH_PRODUCTS";
    TileType[TileType["BRAND_TILE_WITH_ACTION"] = 2] = "BRAND_TILE_WITH_ACTION";
    TileType[TileType["PRODUCTS_WITH_BRAND_INFO_TILE"] = 3] = "PRODUCTS_WITH_BRAND_INFO_TILE";
    TileType[TileType["PRODUCT_TILE"] = 4] = "PRODUCT_TILE";
    TileType[TileType["IMAGE_TILE"] = 5] = "IMAGE_TILE";
    TileType[TileType["PILL_TILE"] = 6] = "PILL_TILE";
    TileType[TileType["IMAGE_GALLERY_TILE"] = 7] = "IMAGE_GALLERY_TILE";
    TileType[TileType["TEXT_TILE"] = 8] = "TEXT_TILE";
    TileType[TileType["AVATAR_TILE"] = 9] = "AVATAR_TILE";
    TileType[TileType["BRAND_INSIGHTS_TILE"] = 10] = "BRAND_INSIGHTS_TILE";
})(TileType || (TileType = {}));
var _obj;
var tileRendererMap = (_obj = {}, _define_property(_obj, TileType.BRAND_TILE, SDUIBrandTileRenderer), _define_property(_obj, TileType.BRAND_TILE_WITH_ACTION, SDUIBrandTileWithActionRenderer), _define_property(_obj, TileType.PRODUCTS_WITH_BRAND_INFO_TILE, SDUIProductTileWithBrand), _define_property(_obj, TileType.PRODUCT_TILE, SDUIProductTileRenderer), _define_property(_obj, TileType.IMAGE_TILE, SDUIImageTileRenderer), _define_property(_obj, TileType.PILL_TILE, SDUIPillTileRenderer), _define_property(_obj, TileType.IMAGE_GALLERY_TILE, SDUIImageGalleryTileRenderer), _define_property(_obj, TileType.TEXT_TILE, SDUITextTileRenderer), _define_property(_obj, TileType.AVATAR_TILE, SDUIAvatarTileRenderer), _define_property(_obj, TileType.BRAND_INSIGHTS_TILE, SDUIBrandInsightsTileRenderer), _obj);
var getTileComponent = function(tileElement) {
    if (tileElement.brand_tile) {
        return tileRendererMap[TileType.BRAND_TILE];
    } else if (tileElement.brand_tile_with_action) {
        return tileRendererMap[TileType.BRAND_TILE_WITH_ACTION];
    } else if (tileElement.product_tile) {
        return tileRendererMap[TileType.PRODUCT_TILE];
    } else if (tileElement.product_with_brand_info_tile) {
        return tileRendererMap[TileType.PRODUCTS_WITH_BRAND_INFO_TILE];
    } else if (tileElement.image_tile) {
        return tileRendererMap[TileType.IMAGE_TILE];
    } else if (tileElement.pill_tile) {
        return tileRendererMap[TileType.PILL_TILE];
    } else if (tileElement.image_gallery_tile) {
        return tileRendererMap[TileType.IMAGE_GALLERY_TILE];
    } else if (tileElement.text_tile) {
        return tileRendererMap[TileType.TEXT_TILE];
    } else if (tileElement.avatar_tile) {
        return tileRendererMap[TileType.AVATAR_TILE];
    } else if (tileElement.brand_insights_tile) {
        return tileRendererMap[TileType.BRAND_INSIGHTS_TILE];
    }
    return undefined;
};
